import React from 'react';

const TermsConditions = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 pt-36 pb-24 font-sans">
      <h1 className="text-[32px] font-bold text-secondary mb-6">Vendor Agreement</h1>
      
      <div className="space-y-6 text-[#555] text-[15px] leading-relaxed">
        <p className="font-medium text-gray-700">
          This Vendor Agreement is entered into between Top Interiors India (a vertical under IMIAD Consultancy Services Pvt Ltd) and the registered vendor using the platform.
        </p>
        <p className="font-medium text-gray-700">
          By registering or purchasing a listing on the Top Interiors India Vendor Portal, the vendor agrees to the following terms.
        </p>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">1. Platform Role</h2>
          <p className="mb-2">
            Top Interiors India operates as a media and vendor discovery platform connecting vendors with architects, interior designers, and industry professionals across India.
          </p>
          <p>
            The platform only provides visibility and networking opportunities and does not participate in transactions between vendors and clients.
          </p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">2. Vendor Responsibilities</h2>
          <p className="mb-2">The vendor agrees to:</p>
          <ul className="list-disc pl-6 space-y-1 mb-2">
            <li>Provide accurate company and contact information</li>
            <li>Ensure product/service descriptions are truthful</li>
            <li>Maintain professional communication with users</li>
            <li>Comply with applicable laws and business regulations</li>
          </ul>
          <p>
            Vendors are fully responsible for their services, products, and commitments made to clients.
          </p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">3. Subscription & Payment</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Vendor listings are offered on a yearly subscription basis.</li>
            <li>Once the listing is activated, payments are non-refundable.</li>
            <li>Listings remain active for the duration of the selected plan.</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">4. No Business Guarantee</h2>
          <p className="mb-2">Top Interiors India provides visibility only.</p>
          <p className="mb-2">The platform does not guarantee:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Business leads</li>
            <li>Project inquiries</li>
            <li>Sales conversions</li>
            <li>Project outcomes</li>
          </ul>
          <p className="mt-2">Results may vary depending on vendor category, demand, and user engagement.</p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">5. Vendor Listing Visibility</h2>
          <p className="mb-2">Vendor listings may appear on the platform based on:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Subscription plan</li>
            <li>Category relevance</li>
            <li>Platform algorithm</li>
            <li>Promotional campaigns</li>
          </ul>
          <p className="mt-2">Top Interiors India does not guarantee fixed listing positions unless explicitly stated in the selected plan.</p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">6. Vendor Verification Disclaimer</h2>
          <p className="mb-2">Top Interiors India does not independently verify all vendor credentials.</p>
          <p className="mb-2">Users are advised to conduct their own due diligence before engaging with any vendor.</p>
          <p className="mb-2">The platform is not responsible for:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Service quality</li>
            <li>Product quality</li>
            <li>Project disputes</li>
            <li>Payment disagreements</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">7. Use of Vendor Content</h2>
          <p className="mb-2">By registering on the platform, vendors grant Top Interiors India permission to use:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Company name</li>
            <li>Logo</li>
            <li>Images</li>
            <li>Product details</li>
          </ul>
          <p className="mt-2">for platform promotion, marketing, and social media communication.</p>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">8. Account Suspension</h2>
          <p className="mb-2">Top Interiors India reserves the right to remove or suspend vendor listings if:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>False information is provided</li>
            <li>Platform policies are violated</li>
            <li>Illegal or misleading content is posted</li>
          </ul>
        </section>

        <section>
          <h2 className="text-[20px] font-bold text-secondary mb-3">9. Agreement Acceptance</h2>
          <p>
            By registering or purchasing a listing on the platform, the vendor confirms acceptance of this agreement.
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;
